import { render, staticRenderFns } from "./PatientJourney.vue?vue&type=template&id=a05b98c0"
import script from "./PatientJourney.vue?vue&type=script&lang=js"
export * from "./PatientJourney.vue?vue&type=script&lang=js"
import style0 from "./PatientJourney.vue?vue&type=style&index=0&id=a05b98c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports